import { Component, Input } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { getLocale } from '@vendasta/galaxy/utility/locale';
import { DayOfWeek, RegularHoursPeriod, TimeOfDayInterface } from '@vendasta/listing-products';

@Component({
  selector: 'forms-regular-hours-display',
  templateUrl: './regular-hours-display.component.html',
  styleUrls: ['./regular-hours-display.component.scss'],
  standalone: false,
})
export class RegularHoursDisplayComponent {
  @Input() dayOfWeek: DayOfWeek;
  @Input() control: UntypedFormControl;

  // make this constant available to the template
  DayOfWeek = DayOfWeek;

  get hours(): RegularHoursPeriod[] {
    return this.control.value?.filter((period: RegularHoursPeriod) => {
      if (period.openDay) {
        return this.dayOfWeek === period.openDay;
      }
      return false;
    });
  }

  displayTime(time: TimeOfDayInterface): string {
    if (!time) {
      return '';
    }
    const hours = time.hours || 0;
    const minutes = time.minutes || 0;
    const now = new Date();
    now.setHours(hours, minutes);

    const formatter = Intl.DateTimeFormat(getLocale().code, { timeStyle: 'short' });

    return formatter.format(now);
  }

  is24Hour(period: RegularHoursPeriod): boolean {
    if (!period.openTime && !period.closeTime) {
      return true;
    }

    if (period.openTime.hours === 0 && (!period.closeTime || period.closeTime.hours === 24)) {
      return true;
    }

    return period.openTime.hours === period.closeTime.hours && period.openTime.minutes === period.closeTime.minutes;
  }

  hasTime(period: RegularHoursPeriod): boolean {
    return !!period.openTime || !!period.closeTime;
  }

  dayDisplayNameKey(day: DayOfWeek): string {
    switch (day) {
      case DayOfWeek.SUNDAY:
        return 'FRONTEND.FORMS.HOURS_OF_OPERATION.SUNDAY';
      case DayOfWeek.MONDAY:
        return 'FRONTEND.FORMS.HOURS_OF_OPERATION.MONDAY';
      case DayOfWeek.TUESDAY:
        return 'FRONTEND.FORMS.HOURS_OF_OPERATION.TUESDAY';
      case DayOfWeek.WEDNESDAY:
        return 'FRONTEND.FORMS.HOURS_OF_OPERATION.WEDNESDAY';
      case DayOfWeek.THURSDAY:
        return 'FRONTEND.FORMS.HOURS_OF_OPERATION.THURSDAY';
      case DayOfWeek.FRIDAY:
        return 'FRONTEND.FORMS.HOURS_OF_OPERATION.FRIDAY';
      case DayOfWeek.SATURDAY:
        return 'FRONTEND.FORMS.HOURS_OF_OPERATION.SATURDAY';
    }
    return day.toLocaleString(getLocale().code);
  }
}
